export default {
	ConnectInvoices: [],
	ConnectInvoicesTotal: 0,
	MisaIdInfo: {}
};
